export default "__VITE_ASSET__DgF2PDr7__"